import {
    CommunityCommentContract,
    CommunityContentContract,
    LikeCountContract,
    LikeType,
} from '@polaris-customerweb/sharedcomponents.core';
import { cloneDeep } from 'lodash-es';

export class CommunityFeedback {
    private _highestRatingCount = 0;
    private contract: CommunityContentContract;

    constructor(contract: CommunityContentContract = {}) {
        this.contract = cloneDeep(contract);
    }

    get ratingAverage(): number {
        return this.contract.ratings?.avg || 0;
    }

    get ratingCount(): number {
        return this.contract.ratings?.tot || 0;
    }

    get ratingCount1(): number {
        return this.contract.ratings?.ct1 || 0;
    }

    get ratingCount2(): number {
        return this.contract.ratings?.ct2 || 0;
    }

    get ratingCount3(): number {
        return this.contract.ratings?.ct3 || 0;
    }

    get ratingCount4(): number {
        return this.contract.ratings?.ct4 || 0;
    }

    get ratingCount5(): number {
        return this.contract.ratings?.ct5 || 0;
    }

    get ratingPercent1(): number {
        return (this.ratingCount1 / this.highestRatingCount) * 100;
    }

    get ratingPercent2(): number {
        return (this.ratingCount2 / this.highestRatingCount) * 100;
    }

    get ratingPercent3(): number {
        return (this.ratingCount3 / this.highestRatingCount) * 100;
    }

    get ratingPercent4(): number {
        return (this.ratingCount4 / this.highestRatingCount) * 100;
    }

    get ratingPercent5(): number {
        return (this.ratingCount5 / this.highestRatingCount) * 100;
    }

    get myRating(): number {
        return this.contract.ratings?.myRating || 0;
    }

    get myLikeType(): LikeType {
        return this.contract.myLikeType || 'Unknown';
    }

    // TODO: replace dto with model
    get likeCounts(): LikeCountContract[] {
        return this.contract.likeCounts || [];
    }

    get numberOfLikes(): number {
        let likes: LikeCountContract[] = [];
        likes =
            this.contract.likeCounts?.filter((like) => like.type === 'Like') ||
            [];
        if (likes?.length > 0) {
            return likes[0].count ?? 0;
        }
        return 0;
    }

    // TODO: replace dto with model
    get comments(): CommunityCommentContract[] {
        return this.contract.comments || [];
    }

    private get highestRatingCount(): number {
        this._highestRatingCount = Math.max(
            this.ratingCount1,
            this.ratingCount2,
            this.ratingCount3,
            this.ratingCount4,
            this.ratingCount5
        );

        return this._highestRatingCount;
    }

    toContract(): CommunityContentContract {
        return cloneDeep(this.contract);
    }
}
